import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Navigation from './components/Navigation';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import NewsFeed from './pages/NewsFeed';
import Attendance from './pages/Attendance';
import EmployeeAttendance from './pages/EmployeeAttendance';
import Leaves from './pages/Leaves';
import WorkFromHome from './pages/WorkFromHome';
import Holidays from './pages/Holidays';
import Files from './pages/Files';
import Reports from './pages/Reports';
import Users from './pages/Users';
import BCPMatrix from './pages/BCPMatrix';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Navigation />
          </PrivateRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="profile" element={<Profile />} />
        <Route path="news" element={<NewsFeed />} />
        <Route path="attendance" element={<Attendance />} />
        <Route path="employee-attendance" element={<EmployeeAttendance />} />
        <Route path="leaves" element={<Leaves />} />
        <Route path="wfh" element={<WorkFromHome />} />
        <Route path="holidays" element={<Holidays />} />
        <Route path="files" element={<Files />} />
        <Route path="reports" element={<Reports />} />
        <Route path="employees" element={<Users />} />
        <Route path="bcp-matrix" element={<BCPMatrix />} />
      </Route>
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
